<!--考核配置表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm" />
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" @click="onCreate">新建</a-button>
        <create-configuration ref="createConfigurationRef" @finish="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs :default-active-key="currentTab" type="card" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.name"></a-tab-pane>
        </a-tabs>
        <!-- 表格 -->
        <ls-api-table
          class="pre-order-demand-table"
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1400 }">
          <!--得分或分配比例展示/编辑-->
          <template slot="scoreStr" slot-scope="text">
            <a-input-number
              v-if="isEdit && currentId === text.record.id && ['1', '2'].includes(text.record.type)"
              style="width: 100%"
              v-model="text.record.score"
              :min="0"
              :max="100"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
            <a-input-number
              v-else-if="isEdit && currentId === text.record.id && text.record.type === '3'"
              style="width: 100%"
              v-model="text.record.score"
              :min="0"
              :max="1"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
            />
            <span v-else>{{ text.record.scoreStr }}</span>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
            <a class="ml10" @click="handleDel(text.record)">删除</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import createConfiguration from '@/views/finished-goods-order/base-data/assessment-configuration/create-configuration'
import {
  apiDeleteScpMpsAppraiseConfigFd,
  apiScpMpsAppraiseConfigFdList,
  apiUpdateScpMpsAppraiseConfigFd
} from '@/api/finished-goods-order'

export default {
  name: 'AssessmentConfiguration',
  components: { createConfiguration },
  data() {
    return {
      currentTab: "afterSalesScore", // 页签
      tabList: [
        { key: "afterSalesScore", name: '售后得分', type: '1' },
        { key: "priceScore", name: '价格得分', type: '2' },
        { key: "distributionRatio", name: '分配比例', type: '3' }
      ],
      type: "1", // tab类型, 默认售后得分
      isEdit: false,
      loading: false,
      currentId: "",
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMpsAppraiseConfigFdList, false),
        pageCurrent: true
      },
      queryParams: { rank: undefined }, // 查询参数
      formList: [
        { label: '排名', decorator: ['rank'], type: 'input' }
      ],
      columns: [],
      rankingColumns: [
        { title: '排名', dataIndex: 'rank', align: 'center' },
        { title: '得分', dataIndex: 'scoreStr', align: 'center', scopedSlots: { customRender: 'scoreStr' } },
        { title: '操作', width: 140, dataIndex: 'operation', align: 'center', scopedSlots: { customRender: 'operation' }, stickyFixed: 'right' }
      ],
      proportionColumns: [
        { title: '排名', dataIndex: 'rank', align: 'center' },
        { title: '分配比例', dataIndex: 'scoreStr', align: 'center', scopedSlots: { customRender: 'scoreStr' } },
        { title: '操作', width: 140, dataIndex: 'operation', align: 'center', scopedSlots: { customRender: 'operation' }, stickyFixed: 'right' }
      ]
    }
  },
  created() {
    this.columns = JSON.parse(JSON.stringify(this.rankingColumns))
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 新建
    onCreate() {
      this.$refs.createConfigurationRef.show(this.currentTab, this.type)
    },
    // 删除
    handleDel(data) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.loading = true
          apiDeleteScpMpsAppraiseConfigFd(data.id).then(res => {
            if (res.code === 200) {
              self.$message.success('删除成功')
              self.handleOk()
            } else {
              self.$message.error(res?.msg)
            }
          }).finally(() => {
            self.loading = false
          })
        }
      })
    },
    // 取消
    handleCancel() {
      this.isEdit = false;
      this.currentId = '';
      this.handleOk(true)
    },
    // 保存
    handleSave(data) {
      this.loading = true
      const params = { id: data?.id, type: data.type, rank: data.rank, score: data.score }
      apiUpdateScpMpsAppraiseConfigFd(params).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.isEdit = false;
          this.currentId = '';
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = cloneDeep(record.id);
    },
    // 页签-切换
    tabOnchange (val) {
      this.currentTab = val
      if (val === "afterSalesScore") {
        this.columns = JSON.parse(JSON.stringify(this.rankingColumns))
        this.type = "1"
      }
      if (val === "priceScore") {
        this.columns = JSON.parse(JSON.stringify(this.rankingColumns))
        this.type = "2"
      }
      if (val === "distributionRatio") {
        this.columns = JSON.parse(JSON.stringify(this.proportionColumns))
        this.type = "3"
      }
      this.handleOk()
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.loading = false;
      this.isEdit = false
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.type = this.type // 标识tab，必传。1：售后得分，2：价格得分，3：分配比例
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = { rank: undefined }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less"></style>
